import PropTypes from 'prop-types';

/**
 * Radio Component (Preline UI)
 *
 * Radio button input with label following Preline design patterns.
 *
 * @param {Object} props
 * @param {string} props.label - Radio button label text
 * @param {boolean} props.checked - Whether radio is selected
 * @param {Function} props.onChange - Callback when selection changes (receives value)
 * @param {string} props.value - Value of this radio option
 * @param {boolean} props.disabled - Whether radio is disabled
 * @param {string} props.name - Radio group name attribute (all radios in group must share same name)
 * @param {string} props.id - Radio id attribute
 */
export function Radio({ label, checked, onChange, value, disabled = false, name, id }) {
  const radioId = id || `${name}-${value}`;

  return (
    <div className="flex items-center">
      <input
        type="radio"
        className="shrink-0 size-5 border-border-strong rounded-full text-brand focus:ring-brand disabled:opacity-50 disabled:pointer-events-none cursor-pointer"
        id={radioId}
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
      />
      <label htmlFor={radioId} className="text-base text-default ms-3 cursor-pointer dark:text-neutral-200">
        {label}
      </label>
    </div>
  );
}

Radio.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
};
